import { Link } from "react-router-dom";

export default function ServicesHero() {
  return (
    <section className="relative pt-32 md:pt-40 pb-16 md:pb-20 bg-gradient-to-br from-[#FAF5EC] via-cream-50 to-[#F5EBDA] overflow-hidden">
      {/* Decorative blob */}
      <div className="absolute top-32 right-0 w-[480px] h-[480px] rounded-full bg-brand-200/30 blur-3xl pointer-events-none"></div>
      <div className="absolute bottom-0 left-1/4 w-[360px] h-[360px] rounded-full bg-amber-200/40 blur-3xl pointer-events-none"></div>

      <div className="relative max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl">
          <nav className="flex items-center gap-2 text-xs font-semibold text-ink-500 mb-6">
            <Link to="/" className="hover:text-brand-600 cursor-pointer">Home</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-ink-900">Services</span>
          </nav>

          <div className="text-xs uppercase tracking-[0.18em] text-brand-600 font-bold mb-3">
            Full-service moving company
          </div>
          <h1 className="font-display text-4xl md:text-6xl font-bold text-ink-900 leading-tight tracking-tight mb-6">
            From a studio apartment to a 22-person office — we move it all.
          </h1>
          <p className="text-base md:text-lg text-ink-600 leading-relaxed max-w-2xl mb-8">
            Six core service lines, one crew. Whether you're moving across the street or across the country, you get the same flat-rate pricing, background-checked movers, and on-time guarantee.
          </p>

          <div className="flex flex-wrap items-center gap-2.5">
            {["Residential", "Commercial", "Long Distance", "Packing", "Storage", "Specialty"].map((t) => (
              <a
                key={t}
                href={`#${t.toLowerCase().replace(/\s+/g, "-")}`}
                className="px-3.5 py-1.5 rounded-full bg-white border border-ink-200 hover:border-brand-500 hover:text-brand-600 text-xs font-semibold text-ink-700 cursor-pointer transition-colors"
              >
                {t}
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}